import { type RefObject, createContext, useContext } from "react";

const PortalContext = createContext<RefObject<HTMLElement> | undefined>(undefined);

export const PortalContextProvider = PortalContext.Provider;

export const usePortalContext = () => useContext(PortalContext);
